// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Sa6f","importantInfo":"styles_importantInfo__h7bdp"};